import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useApp } from './contexts/AppContext';
import Navbar from './components/Navbar';
import Landing from './pages/Landing';
import Login from './pages/Login';
import StudentProfile from './pages/StudentProfile';
import TeacherDashboard from './pages/TeacherDashboard';
import AdminDashboard from './pages/AdminDashboard';
import AcceptInvitation from './pages/AcceptInvitation';
import CurriculumPage from './pages/CurriculumPage';
import Orientation from './pages/Orientation';
import Roulette from './pages/Roulette';

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useApp();
  if (loading) return <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
    <div style={{ fontSize: '2rem', animation: 'spin 1s linear infinite' }}>⭐</div>
  </div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function ChromeNavbar() {
  // Hidden on the full-screen orientation deck — it's meant to be projected
  // edge-to-edge with its own exit control, not the regular site chrome.
  const location = useLocation();
  if (location.pathname.startsWith('/orientation')) return null;
  return <Navbar />;
}

function NotFound() {
  const { t } = useApp();
  return (
    <div className="summer-bg d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
      <div className="text-center">
        <div style={{ fontSize: '5rem' }}>🌊</div>
        <h2 style={{ fontWeight: 900, margin: '1rem 0' }}>{t.notFound}</h2>
        <a href="/" className="btn-summer text-decoration-none">{t.backHome}</a>
      </div>
    </div>
  );
}

export default function App() {
  const { lang } = useApp();
  return (
    <div className={`lang-${lang}`}>
      <BrowserRouter>
        <ChromeNavbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/accept-invitation" element={<AcceptInvitation />} />
          <Route path="/curriculum" element={
            <ProtectedRoute roles={['student', 'teacher', 'admin']}>
              <CurriculumPage />
            </ProtectedRoute>
          } />

          <Route path="/orientation" element={
            <ProtectedRoute roles={['teacher', 'admin']}>
              <Orientation />
            </ProtectedRoute>
          } />

          <Route path="/profile" element={
            <ProtectedRoute roles={['student']}>
              <StudentProfile />
            </ProtectedRoute>
          } />

          <Route path="/student/:slug" element={
            <ProtectedRoute roles={['student', 'teacher', 'admin']}>
              <StudentProfile />
            </ProtectedRoute>
          } />

          <Route path="/roulette" element={
            <ProtectedRoute roles={['teacher', 'admin']}>
              <Roulette />
            </ProtectedRoute>
          } />

          <Route path="/dashboard" element={
            <ProtectedRoute roles={['teacher', 'admin']}>
              <TeacherDashboard />
            </ProtectedRoute>
          } />

          <Route path="/admin" element={
            <ProtectedRoute roles={['admin']}>
              <AdminDashboard />
            </ProtectedRoute>
          } />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
